<template>
  <div class="contents-block dx-card responsive-paddings">
    <DxForm>
      <DxColCountByScreen :xs="1" :sm="2" :md="3" :lg="4" />

      <DxSimpleItem>
        <div class="dx-card">
          <div class="frame">
            <div class="cardName">일일 방문자</div>
            <div class="cardValue">{{ summaryData.todayVisitUserCnt }}</div>
          </div>
        </div>
      </DxSimpleItem>

      <DxSimpleItem>
        <div class="dx-card">
          <div class="frame">
            <div class="cardName">일일 접속 수</div>
            <div class="cardValue">{{ summaryData.todayVisitCnt }}</div>
          </div>
        </div>
      </DxSimpleItem>

      <DxSimpleItem>
        <div class="dx-card">
          <div class="frame">
            <div class="cardName">일일 콘텐츠 클릭수</div>
            <div class="cardValue">{{ summaryData.todayContentsUseCnt }}</div>
          </div>
        </div>
      </DxSimpleItem>

      <DxSimpleItem>
        <div class="dx-card">
          <div class="frame">
            <div class="cardName">누적 방문자</div>
            <div class="cardValue">{{ summaryData.totalVisitUserCnt }}</div>
          </div>
        </div>
      </DxSimpleItem>

      <DxSimpleItem>
        <div class="dx-card">
          <div class="frame">
            <div class="cardName">누적 접속 수</div>
            <div class="cardValue">{{ summaryData.totalVisitCnt }}</div>
          </div>
        </div>
      </DxSimpleItem>

      <DxSimpleItem>
        <div class="dx-card">
          <div class="frame">
            <div class="cardName">누적 콘텐츠 클릭수</div>
            <div class="cardValue">{{ summaryData.totalContentsUseCnt }}</div>
          </div>
        </div>
      </DxSimpleItem>
    </DxForm>
  </div>

  <div class="contents-block dx-card responsive-paddings">
    <DxForm :ref="searchFormRefName" label-location="left" :form-data="formData">

      <DxColCountByScreen :xs="1" :sm="2" :md="3" :lg="4" />

      <DxSimpleItem data-field="spaceId" editor-type="dxSelectBox"
        :editor-options="{ dataSource: spaceList, valueExpr: 'spaceId', displayExpr: 'spaceNameId', value: selectedSapceId, onValueChanged:onSpaceIdChanged}">
        <DxLabel text="스페이스" />
        <DxRequiredRule />
      </DxSimpleItem>

      <DxSimpleItem data-field="startDate" editor-type="dxDateBox"
        :editor-options="{ displayFormat: 'yyyy/MM/dd', value: defaultStartDate }">
        <DxLabel text="시작 날짜" />
        <DxRequiredRule />
      </DxSimpleItem>

      <DxSimpleItem data-field="endDate" editor-type="dxDateBox"
        :editor-options="{ displayFormat: 'yyyy/MM/dd', value: defaultEndDate }">
        <DxLabel text="끝 날짜" />
        <DxRequiredRule />
      </DxSimpleItem>
      <DxButtonItem horizontal-alignment="center" vertical-alignment="center" :buttonOptions="{
        text: '조회',
        icon: 'search',
        onClick: searchData
      }" />
    </DxForm>
  </div>

  <div class="contents-block dx-card responsive-paddings">
    <DxDataGrid id="map" :ref="gridMapRefName" :dataSource="mapSummaryData" :show-borders="true" :show-column-lines="true"
      :columnAutoWidth="true" @cell-prepared="onCellPrepared" @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparingMap($event)">

      <DxSearchPanel :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="infinite" />
      <DxSorting mode="none" />
      <DxExport :enabled="true" />

      <DxColumn data-field="mapName" caption="맵 이름" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="totalCnt" caption="총 접속 수" data-type="number" :minWidth="150"
        :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="pcCnt" caption="PC 접속 수" data-type="number" :minWidth="150"
        :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="mobileCnt" caption="모바일 접속 수" data-type="number" :minWidth="150"
        :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="avgTime" caption="평균 접속 시간(분)" data-type="number" :minWidth="150"
        :header-filter="{ allowSearch: true }">
      </DxColumn>

      <template #gridSubjectTemplateMap>
        <div class="gridSubject">맵별 접속 통계</div>
      </template>

    </DxDataGrid>
  </div>

  <div class="contents-block dx-card responsive-paddings">
    <DxDataGrid id="contents" :ref="gridContentsRefName" :dataSource="contentsSummaryData" :show-borders="true"
      :show-column-lines="true" :columnAutoWidth="true" @cell-prepared="onCellPrepared" @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparingContents($event)">

      <DxSearchPanel :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="infinite" />
      <DxSorting mode="none" />
      <DxExport :enabled="true" />

      <DxColumn data-field="mapName" caption="맵 이름" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="contentName" caption="콘텐츠 이름" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="totalCnt" caption="총 클릭 수" data-type="number" :minWidth="150"
        :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="avgCnt" caption="인당 평균 클릭 수" data-type="number" :minWidth="150"
        :header-filter="{ allowSearch: true }">
      </DxColumn>

      <template #gridSubjectTemplateContents>
        <div class="gridSubject">콘텐츠 클릭 통계</div>
      </template>

    </DxDataGrid>
  </div>
</template>
  
<script>

var endDate = new Date();
var startDate = new Date();
startDate.setDate(endDate.getDate());
var defaultStartDate = startDate;
var defaultEndDate = endDate;

import {
  DxForm,
  DxColCountByScreen,
  DxSimpleItem,
  DxButtonItem,
  DxLabel,
  DxRequiredRule
} from "devextreme-vue/form";
import {
  DxDataGrid,
  DxScrolling,
  DxColumn,
  DxSorting,
  DxSearchPanel,
  DxHeaderFilter,
  DxExport
} from "devextreme-vue/data-grid";

import dsu from "../../utils/dataSourceUtils";
import fn from "../../utils/function";

export default {
  components: {
    DxForm,
    DxColCountByScreen,
    DxSimpleItem,
    DxButtonItem,
    DxLabel,
    DxRequiredRule,
    DxDataGrid,
    DxScrolling,
    DxColumn,
    DxSorting,
    DxSearchPanel,
    DxHeaderFilter,
    DxExport
  },
  data() {
    return {
      searchFormRefName: 'searchForm',
      formData: {},
      searchConditionData: {},
      defaultStartDate: defaultStartDate,
      defaultEndDate: defaultEndDate,
      mapSummaryData: [],
      onToolbarPreparingMap(e) {
        e.toolbarOptions.items.unshift(
          {
            location: 'before',
            template: 'gridSubjectTemplateMap'
          }
        );
      },
      contentsSummaryData: [],
      onToolbarPreparingContents(e) {
        e.toolbarOptions.items.unshift(
          {
            location: 'before',
            template: 'gridSubjectTemplateContents'
          }
        );
      },
      gridMapRefName: 'gridMap',
      gridContentsRefName: 'gridContents',
      summaryData: {},
      spaceList: [],
      selectedSapceId: ''
    };
  },
  mounted() {
      dsu.getAxiosSpaceAuth().then(res => { this.spaceList = res.data.data 
      this.selectedSapceId = this.spaceList[0].spaceId;
      setTimeout(this.searchData, 1500);
    });
  },
  computed: {
    gridMap: function () { return this.$refs[this.gridMapRefName].instance; },
    gridContents: function () { return this.$refs[this.gridContentsRefName].instance; }
  },
  methods: {
    getSummaryData() {
      this.summaryData.todayVisitUserCnt = '조회 중..';
      this.summaryData.todayVisitCnt = '조회 중..';
      this.summaryData.todayContentsUseCnt = '조회 중..';
      this.summaryData.totalVisitUserCnt = '조회 중..';
      this.summaryData.totalVisitCnt = '조회 중..';
      this.summaryData.totalContentsUseCnt = '조회 중..';

      dsu.getAxiosOBJGet('/api/UVMC/selectSummaryInfo', this.searchConditionData).then(res => {
        let response = res.data;
        if (response.result == 'SUCCESS') {
          this.summaryData = response.data[0];
        } else {
          fn.notifyError(response.msg);
        }
      });
    },
    searchData() {
      const searchForm = this.$refs[this.searchFormRefName].instance;
      let validationResult = searchForm.validate();
      if (validationResult.status != 'valid') {
        return;
      }
      Object.assign(this.searchConditionData, this.formData);
      this.searchConditionData.startDate = dsu.getFormatDate(this.searchConditionData.startDate);
      this.searchConditionData.endDate = dsu.getFormatDate(this.searchConditionData.endDate);
      this.gridMap.beginCustomLoading();
      this.gridContents.beginCustomLoading();
      dsu.getAxiosOBJGet('/api/UVMC/selectMapSummaryData', this.searchConditionData).then(res => {
        let response = res.data;
        if (response.result == 'SUCCESS') {
          this.mapSummaryData = response.data;

          let sumTotalCnt = 0;
          let sumPcCnt = 0;
          let sumMobileCnt = 0;
          let sumAvgTime = 0;

          for (let i = 0; i < this.mapSummaryData.length; i++) {
            sumTotalCnt += this.mapSummaryData[i].totalCnt;
            sumPcCnt += this.mapSummaryData[i].pcCnt;
            sumMobileCnt += this.mapSummaryData[i].mobileCnt;
            sumAvgTime += parseFloat(this.mapSummaryData[i].avgTime);
          }
          sumAvgTime = Math.round(sumAvgTime * 10) / 10;
          this.mapSummaryData.push({ mapName: '총계', totalCnt: sumTotalCnt, pcCnt: sumPcCnt, mobileCnt: sumMobileCnt, avgTime: sumAvgTime });

        } else {
          fn.notifyError(response.msg);
        }
        this.gridMap.endCustomLoading();
      });

      dsu.getAxiosOBJGet('/api/UVMC/selectContentsSummaryData', this.searchConditionData).then(res => {
        let response = res.data;
        if (response.result == 'SUCCESS') {
          this.contentsSummaryData = response.data;

          let sumTotalCnt = 0;
          let sumAvgCnt = 0;

          for (let i = 0; i < this.contentsSummaryData.length; i++) {
            sumTotalCnt += this.contentsSummaryData[i].totalCnt;
            sumAvgCnt += parseFloat(this.contentsSummaryData[i].avgCnt);
          }

          sumAvgCnt = Math.round(sumAvgCnt * 10) / 10;

          this.contentsSummaryData.push({ mapName: '총계', contentName: '', totalCnt: sumTotalCnt, avgCnt: sumAvgCnt });

        } else {
          fn.notifyError(response.msg);
        }
        this.gridContents.endCustomLoading();
      });

      this.getSummaryData();
    },
    onCellPrepared(e) {
      if (e.rowType == 'data') {
        if (e.column.dataField) {
          if (this.mapSummaryData[0] === e.data
            || this.contentsSummaryData[0] === e.data) {
            e.cellElement.bgColor = '#ffdee6';
          }

          if (this.mapSummaryData[this.mapSummaryData.length - 1] === e.data
            || this.contentsSummaryData[this.contentsSummaryData.length - 1] === e.data) {
            e.cellElement.bgColor = '#f7f5f5';
          }
        }
      }
    },
    onExporting(e) {
      e.fileName = this.$route.meta.transName;
    },
    onSpaceIdChanged(e){
      this.selectedSapceId = e.value;
    }
  }
};
</script>
  
<style scoped> .dx-card {
   text-align: center;
 }

 .frame {
   height: 110px;
 }

 .cardName {
   margin-top: 20px;
   font-size: 20px;
 }

 .cardValue {
   font-size: 60px;
 }

 #map {
   height: 500px;
 }

 #contents {
   height: 500px;
 }
</style>